export enum CollectiveActionType {
    Add,
    Overwrite,
    Delete
}